module.exports = __webpack_public_path__ + "4696424dd31675384c0902ef73784b44.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-56.cur
// module id = 465
// module chunks = 0